module.exports = __webpack_public_path__ + "static/media/legal.dca344bc.svg";